//--------------- IMPORTAÇÕES ---------------//
import { useContext } from "react";
import { TrackingContext } from "../context/TrackingContext";



//--------------- EXPORTAÇÃO DO COMPONENTE MAIN ---------------//
export default function TableTracking() {



    //--------------- CRIAÇÃO DE HOOKS ---------------//
    const { events, setEvents } = useContext(TrackingContext); // Estado que armazena a lista de eventos existentes
    const { isOpenModalEventsTracking, setIsOpenModalEventsTracking } = useContext(TrackingContext);
    const { formDataModalEventTracking, setFormDataModalEventTracking } = useContext(TrackingContext); // Estado que armazena o ID do Visitor Selecionado pelo usuário



    //--------------- RETORNO DO COMPONENTE MAIN ---------------//
    return (
        <>

            {/* DIV DA TABELA DE TRACKING */}
            <div className="bg-surface-2 rounded-xl overflow-hidden scrollbar scrollbar-thumb-zinc-700 scrollbar-track-zinc-900 overflow-x-scroll shadow border border-white/[0.08]">

                {/* TABELA */}
                <table className="wi-[1080px] sm:w-full text-xs sm:text-sm table-fxed">

                    {/* CABEÇALHO DA TABELA */}
                    <thead className="bg-surface-3">
                        <tr>
                            {/* <th className="p-3 w-[10%] text-left">Data</th>
                            <th className="p-3 w-[10%] text-left">Evento</th> */}
                            <th className="p-3 w-[25%] text-left">Nome</th>
                            <th className="p-3 w-[20%] text-left">Email</th>
                            <th className="p-3 w-[25%] text-left">UUID</th>
                            {/* <th className="p-3 w-[25%] text-left">URL</th> */}
                            
                            {/* <th className="p-3 w-[10%] text-left">Compra</th> */}
                        </tr>
                    </thead>

                    {/* CORPO DA TABELA */}
                    <tbody>
                        {events.clientes && events.clientes.map((event, idx) => (
                            <tr key={idx} className="border-b border-white/[0.08] hover:bg-surface-2">
                                {/* <td className="p-3 w-[10%]">{new Date(event.timestamp * 1000).toLocaleString()}</td> */}
                                {/* <td className="p-3 w-[10%]">{event.evento}</td> */}
                                <td className="p-3 w-[20%]">{event.nome_cliente || '-'}</td>
                                <td className="p-3 w-[20%]">{event.email || '-'}</td>
                                <td
                                    className="p-3 w-[25%] text-blue-400 underline cursor-pointer"
                                    onClick={() => {
                                        setFormDataModalEventTracking({id: event.visitor_id})
                                        setIsOpenModalEventsTracking(true);
                                    }}
                                >
                                    {event.visitor_id}
                                </td>
                                {/* <td className="p-3 w-[25%] break-all text-blue-400 underline">{event.url_limpa || "-"}</td> */}
                                {/* <td className="p-3 w-[10%]">{event.compra ? '✅' : '❌'}</td> */}
                            </tr>
                        ))}
                        {(!events.clientes || events.clientes.length === 0) && (
                            <tr><td colSpan="3" className="p-4 text-center text-ink-4">Nenhum dado encontrado</td></tr>
                        )}
                    </tbody>
                </table>
            </div>

        </>
    )
}